import { View, Text } from "react-native";
import React from "react";

const Chat = () => {
	return (
		<View>
			<Text>indext.native</Text>
		</View>
	);
};

export default Chat;
